<template>
  <component
    :is="bannerLink ? 'a' : 'div'"
    v-if="bannerImage"
    :href="bannerLink"
    class="desktop-mega-menu__image-wrapper"
    :class="{ 'wide-image': bannerImage.aspectRatio > 1 }"
  >
    <responsive-image
      min-max="400-800"
      :image="bannerImage"
      :alt="bannerImage.alt"
    />
    <div
      class="desktop-mega-menu__image-overlay"
      :style="{
        opacity: bannerOverlayOpacity
      }"
    />
    <h3
      v-if="bannerTitle"
      class="desktop-mega-menu__image-title"
      v-text="bannerTitle"
    />
  </component>
</template>

<script>

/**
 * Component: Mega Menu Image
 * -----------------------------------------------------------------------------
 * @param {Object}  [bannerImage] - Formatted image object for megamenu item.
 * @param {String}  [bannerLink] - Image banner URL.
 * @param {String}  [bannerOverlayOpacity] - Image banner overlay opacity.
 * @param {String}  [bannerTitle] - Title for image banner.
 */
import ResponsiveImage from '~components/responsive-image/responsive-image'

export default {
  name: 'MegaMenuImage',

  components: {
    ResponsiveImage,
  },

  props: {
    bannerLink: {
      type: String,
      default: '',
    },
    bannerImage: {
      type: [Boolean, Object],
      default: false,
    },
    bannerOverlayOpacity: {
      type: String,
      default: '',
    },
    bannerTitle: {
      type: String,
      default: '',
    },
  },
}
</script>
